<template>
  <LoadingMarketCard v-if="isLoading" :size="props.size" />
  <div v-else-if="error" class="size-40 w-full flex justify-center items-center">
    <ib-error-state :label="errorMessage" />
  </div>
  <LazyMarketCard
    v-else-if="market"
    :market="market"
    :limit="props.limit"
    :size="props.size"
    :origin="props.origin"
    :openExternalContracts="props.openExternalContracts"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import LazyMarketCard from './LazyMarketCard.vue';
import LoadingMarketCard from './LoadingMarketCard.vue';
import { useGetCategoryMarkets } from '@/api/forecasttrader.queries';

interface Props {
  underlyingConid: string;
  exchange: string;
  limit?: number;
  size: 'large' | 'small';
  origin?: string;
  openExternalContracts?: boolean;
}

const props = defineProps<Props>();

// Create markets request with underlyingConid and exchange
const marketsRequest = computed(() => ({
  markets: [
    {
      conid: parseInt(props.underlyingConid),
      exchange: props.exchange,
    },
  ],
}));

// Fetch market data using the category markets API
const { data: categoryMarketsData, isLoading, error } = useGetCategoryMarkets(marketsRequest);

// Error message for display
const errorMessage = computed(() => {
  if (error.value) {
    return error.value.message || 'Failed to load market data';
  }
  return '';
});

// Extract the first market from the response
const market = computed(() => {
  if (!categoryMarketsData.value?.markets?.length) {
    return null;
  }
  return categoryMarketsData.value.markets[0];
});
</script>
